import { UserRoles } from '../../enums';

export const USER_ROLE_HINT_MAPPING: Partial<Record<UserRoles, string>> = {
  [UserRoles.TEAM_MEMBER]: 'Team members can have access to specific brands or campaigns.',
  [UserRoles.ACCOUNT_ADMIN]:
    'Account admins have access to all brands and campaigns. Additionally they can invite and modify other team members',
  [UserRoles.ACCOUNT_OWNER]:
    'Account Owner will be contacted with issues regarding billing and invoicing. Account owner has access to all brands and campaigns.'
};
